import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RoutesEnum } from '~/constants/enums';

export default function NotFound() {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;

  return (
    <div className="element-center flex-col my-4x md:my-5x p-2x w-full">
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/not-found-page.svg`}
        width={344}
        height={260}
        alt="not-found-result"
        className="object-contain mb-4x"
      />
      <h3 className="text-title_2 text-black font-[600]">
        {t('notFoundTitle')}
      </h3>
      <p className="text-body_1 text-black font-[400] mb-2x text-center">
        {t('notFoundDescription')}
      </p>
      <div className="flex items-center gap-2x flex-col md:flex-row">
        <Link
          to={`${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.SEARCH_RESULT_ROOT}/`}
          className="h-[48px] w-[163px] bg-blue rounded-[26px] element-center"
        >
          <span className="text-link text-white">{t('researchBtn')}</span>
        </Link>
        <Link
          to={`${process.env.REACT_APP_BASE_URL}/${locale}/`}
          className="h-[48px] w-[163px] bg-gray_light_1 rounded-[26px] font-[700] element-center text-blue"
        >
          {t('homePage')}
        </Link>
      </div>
    </div>
  );
}
